var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaivIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2212 15.6879L15.6824 23.2212C14.644 24.2596 12.9574 24.2596 11.913 23.2212C10.8746 22.1827 10.8746 20.496 11.913 19.4515L19.4518 11.9122C20.4902 10.8738 22.1768 10.8738 23.2212 11.9122C24.2596 12.9567 24.2596 14.6434 23.2212 15.6819V15.6879ZM21.3245 0.783343C20.2861 -0.261114 18.5995 -0.261114 17.5551 0.783343L0.778792 17.5607C-0.259597 18.5991 -0.259597 20.2859 0.778792 21.3303C1.81718 22.3688 3.50381 22.3688 4.54821 21.3303L21.3245 4.55299C22.3629 3.51454 22.3629 1.8278 21.3245 0.783343ZM4.7943 8.05252L8.04752 4.7991C9.08591 3.76065 9.08591 2.0679 8.04752 1.02945C7.00913 -0.00900386 5.3225 -0.00900386 4.2781 1.02945L1.03089 4.28287C-0.013505 5.32733 -0.013505 7.01407 1.03089 8.05252C2.07528 9.09098 3.75591 9.09098 4.8003 8.05252H4.7943Z",
    fill: "#FF6A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaivIcon);
export default __webpack_public_path__ + "static/media/paiv-icon.4dd5555152ff5f8481a4e3702c11d736.svg";
export { ForwardRef as ReactComponent };